<template>
  <div class="logs">
    <h2>服务端日志管理</h2>

    <!-- 日志文件列表 -->
    <div class="logs-section">
      <h3>日志文件列表</h3>
      <button @click="loadLogsList" class="refresh-btn">刷新列表</button>
      <table v-if="logs.length > 0" class="logs-table">
        <thead>
          <tr>
            <th>文件名</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(log, index) in logs" :key="index">
            <td>{{ log }}</td>
            <td>
              <button @click="viewLog(log)" class="view-btn">查看</button>
              <button @click="downloadLog(log)" class="download-btn">下载</button>
            </td>
          </tr>
        </tbody>
      </table>
      <p v-else class="empty-hint">暂无日志文件</p>
    </div>

    <!-- 日志内容展示区 -->
    <div v-if="showContent" class="log-content-section">
      <div class="content-header">
        <h3>日志内容: {{ currentLogName }}</h3>
        <button @click="closeContent" class="close-btn">关闭</button>
      </div>
      <textarea
        v-model="logContent"
        readonly
        class="log-textarea"
      ></textarea>
    </div>
  </div>
</template>

<script>
import axios from "axios"

export default {
  name: 'Logs',
  data () {
    return {
      logs: [],
      logContent: '',
      showContent: false,
      currentLogName: '',
      uid: '',
      token: ''
    }
  },
  mounted() {
    if (sessionStorage.getItem("account") && sessionStorage.getItem("token")) {
      this.uid = sessionStorage.getItem("uid")
      this.token = sessionStorage.getItem("token")
      this.loadLogsList()
    } else {
      alert("请先登录")
      this.$router.push({name: "Login"})
    }
  },
  methods: {
    // 获取日志文件列表
    loadLogsList() {
      const query = {
        uid: this.uid,
        access_token: this.token,
        time: (new Date().getTime() / 1000)
      }
      query.sig = this.checkSig(query)

      const params = []
      for (const key in query) {
        params.push(`${key}=${query[key]}`)
      }

      const url = `${this.WEBCONF.url}admin/downloadlogs?${params.join('&')}`
      console.log('请求URL:', url)

      axios.get(url)
        .then(response => {
          console.log('响应数据:', response.data)
          if (response.status === 200) {
            if (response.data.code === 0) {
              this.logs = response.data.logs || []
              console.log('日志列表:', this.logs)
            } else {
              console.error('接口返回错误:', response.data)
              alert('获取日志列表失败: ' + (response.data.reason || '未知错误'))
            }
          }
        })
        .catch(err => {
          console.error('请求异常:', err)
          console.error('响应:', err.response)
          const reason = err.response && err.response.data && err.response.data.reason
          alert('网络错误，无法获取日志列表: ' + (reason || err.message))
        })
    },

    // 查看日志内容
    viewLog(filename) {
      // 压缩包不能查看，只能下载
      if (filename.endsWith('.tar.gz') || filename.endsWith('.gz')) {
        alert('压缩包只能下载，不能查看')
        return
      }

      const query = {
        uid: this.uid,
        access_token: this.token,
        filename: filename,
        time: (new Date().getTime() / 1000)
      }
      query.sig = this.checkSig(query)

      const params = []
      for (const key in query) {
        params.push(`${key}=${query[key]}`)
      }

      axios.get(`${this.WEBCONF.url}admin/downloadlog?${params.join('&')}`)
        .then(response => {
          if (response.status === 200) {
            this.logContent = response.data
            this.currentLogName = filename
            this.showContent = true
          }
        })
        .catch(err => {
          console.error(err)
          alert('查看日志失败')
        })
    },

    // 下载日志文件
    downloadLog(filename) {
      const query = {
        uid: this.uid,
        access_token: this.token,
        filename: filename,
        time: (new Date().getTime() / 1000)
      }
      query.sig = this.checkSig(query)

      const params = []
      for (const key in query) {
        params.push(`${key}=${query[key]}`)
      }

      // 创建下载链接
      const url = `${this.WEBCONF.url}admin/downloadlog?${params.join('&')}`

      // 对于压缩包，直接触发浏览器下载
      if (filename.endsWith('.tar.gz') || filename.endsWith('.gz')) {
        const link = document.createElement('a')
        link.href = url
        link.download = filename
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      } else {
        // 对于 .log 文件，创建 blob 下载
        axios.get(url, { responseType: 'blob' })
          .then(response => {
            const blob = new Blob([response.data], { type: 'text/plain' })
            const link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = filename
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            window.URL.revokeObjectURL(link.href)
          })
          .catch(err => {
            console.error(err)
            alert('下载失败')
          })
      }
    },

    // 关闭日志内容展示
    closeContent() {
      this.showContent = false
      this.logContent = ''
      this.currentLogName = ''
    }
  }
}
</script>

<style scoped>
.logs {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

h2, h3 {
  color: #2c3e50;
  margin-bottom: 15px;
}

.logs-section {
  margin-bottom: 30px;
}

.refresh-btn {
  padding: 8px 16px;
  background-color: #42b983;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-bottom: 15px;
}

.refresh-btn:hover {
  background-color: #3aa876;
}

.logs-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
}

.logs-table th,
.logs-table td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

.logs-table th {
  background-color: #f5f5f5;
  font-weight: bold;
  color: #2c3e50;
}

.logs-table tr:hover {
  background-color: #f9f9f9;
}

.view-btn {
  padding: 6px 12px;
  background-color: #42b983;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-right: 8px;
}

.view-btn:hover {
  background-color: #3aa876;
}

.download-btn {
  padding: 6px 12px;
  background-color: #2c3e50;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.download-btn:hover {
  background-color: #1a252f;
}

.empty-hint {
  color: #999;
  text-align: center;
  padding: 20px;
}

.log-content-section {
  margin-top: 20px;
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: #fafafa;
}

.content-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.close-btn {
  padding: 6px 12px;
  background-color: #e74c3c;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.close-btn:hover {
  background-color: #c0392b;
}

.log-textarea {
  width: 100%;
  min-height: 500px;
  padding: 15px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-family: 'Consolas', 'Monaco', 'Courier New', monospace;
  font-size: 14px;
  line-height: 1.6;
  resize: vertical;
  background-color: #fff;
  color: #333;
}

.log-textarea:focus {
  outline: none;
  border-color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/Logs.vue